import { Empty } from "antd"
import PropTypes from "prop-types"

EmptyDataComponent.propTypes = {
  description: PropTypes.any
}

export function EmptyDataComponent({ description, ...props }) {
  return (
    <Empty
      image="https://gw.alipayobjects.com/zos/antfincdn/ZHrcdLPrvN/empty.svg"
      description={description}
      {...props} />
  )
}